/**
 * Format an ISO timestamp as a `<input type="datetime-local">` value
 * using UTC clock components. Mirrors the server's UTC storage so
 * round-tripping through the form does not introduce a timezone shift.
 */
export function isoToUtcInput(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
}

/**
 * Inverse of `isoToUtcInput` — interpret a `<input type="datetime-local">`
 * value (e.g. "2026-05-12T03:00") as UTC and return the ISO string.
 */
export function utcInputToIso(input) {
    if (!input) return null;
    return new Date(`${input}:00Z`).toISOString();
}
